export default {
    bannerContentDX: {
        marginTop: '100px'
    },
    bannerContentMata: {
        alignItems: 'flex-start',
        display: 'flex',
        flexDirection: 'column',
        marginTop: '40px',
    },
    boxContainer: {
        border: '1px black'
    },
    button: {
        '&.MuiButton-root': {
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            fontSize: '16px',
            height: '40px',
            letterSpacing: '0.5px',
            marginBottom: '15px',
            minWidth: '80px',
            width: '100%'
        }
    },
    buttonCustom: {
        '&.MuiButton-root': {
            background: '#003168',
            borderRadius: '2px',
            boxShadow: 'none',
            color: '#FFFFFF',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            height: '54px',
            letterSpacing: '0.09px',
            lineHeight: '12px',
            marginBottom: '15px',
            minWidth: '310px',
            width: '100%'
        },
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            borderColor: 'rgba(0, 0, 0, 0.26)',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.26)'
        },
    },
    buttonMagicLink: {
        '&.MuiButton-root': {
            background: '#FFFFFF',
            border: '1px solid #003168',
            borderRadius: '2px',
            color: '#003168',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            height: '54px',
            letterSpacing: '0.09px',
            lineHeight: '20px',
            marginBottom: '15px',
            width: '100%'
        },
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            borderColor: 'rgba(0, 0, 0, 0.26)',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.26)'
        },
    },
    buttonMain: {
        '&.MuiButton-root': {
            background: '#003168',
            borderRadius: '4px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            color: '#FFFFFF',
            fontSize: '16px',
            height: '40px',
            letterSpacing: '0.5px',
            marginBottom: '15px',
            minWidth: '80px',
            width: '100%'
        },
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            borderColor: 'rgba(0, 0, 0, 0.26)',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.26)'
        },
    },
    buttonRequestAccess: {
        '&.MuiButton-root': {
            background: '#FFFFFF',
            border: '1px solid #003168',
            borderRadius: '2px',
            boxShadow: 'none',
            color: '#003168',
            fontFamily: 'Roboto',
            fontSize: '16px',
            fontWeight: 400,
            height: '54px',
            letterSpacing: '0.09px',
            lineHeight: '12px',
            marginBottom: '15px',
            width: '100%'
        },
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            borderColor: 'rgba(0, 0, 0, 0.26)',
            boxShadow: 'none',
            color: 'rgba(0, 0, 0, 0.26)'
        },
    },
    centralButton: {
        '&.MuiButton-root': {
            background: 'rgb(0, 81, 165)',
            borderRadius: '1px',
            boxShadow: 'none',
            boxSizing: 'border-box',
            fontSize: '16px',
            height: '40px',
            letterSpacing: '0.5px',
            marginBottom: '10%',
            minWidth: '100%',
            width: '100%'
        },
        '&:disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.12)',
            borderColor: 'rgba(0, 0, 0, 0.26)',
            boxShadow: 'none'
        },
    },
    centralCheckbox: {
        '& .MuiSvgIcon-root': {
            marginLeft: '8px'
        }
    },
    centralContainer: {
        '@media screen and (max-width: 767px)': {
            flexBasis: '100%',
            maxWidth: '100%'
        },
        '@media screen and (min-width: 768px) and (max-width: 899px)': {
            flexBasis: '100%',
            maxWidth: '100%',
            overflowY: 'auto'
        },
        '@media screen and (min-width: 900px)': {
            flexBasis: '100%',
            maxWidth: '100%'
        },
        background: '#FFFFFF',
        maxWidth: 'fit-content',
        overflowY: 'auto',
        width: '21rem'
    },
    centralHeader: {
        color: 'rgb(0, 81, 165)',
        fontFamily: 'Proxima-Nova, sans-serif',
        fontSize: '24px',
        fontStyle: 'normal',
        fontWeight: '350',
        letterSpacing: '0',
        lineHeight: '1.25'
    },
    centralLanguageButton: {
        background: 'white',
        boxShadow: 'none',
        color: 'rgb(0, 81, 165)',
        float: 'right',
        fontSize: '10px',
        margin: '10px'
    },
    centralLoginContainer: {
        display: 'flex',
        height: 'fit-content',
        margin: '0px 0px',
        overflow: 'auto',
        padding: '20px 32px',
        width: '21rem'
    },
    centralLoginPage: {
        boxShadow: '0 3px 12px rgba(0,0,0,.20)',
        display: 'flex',
        flex: '1',
        maxHeight: 'fit-content',
        MozBoxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.2)',
        overflowY: 'hidden',
        WebKitBoxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.2)'
    },
    centralLogo: {
        marginBottom: '40px',
        maxHeight: '40px',
        width: '150px'
    },
    centralLogoContainer: {
        height: '75px',
        marginRight: '10px'
    },
    centralRememberMeContainer: {
        marginBottom: '12%'
    },
    centralRememberMeLabel: {
        color: 'rgb(51, 51, 51)',
        fontFamily: 'Proxima-Nova, sans-serif',
        fontSize: '14px',
        lineHeight: '1',
        paddingLeft: '18px'
    },
    checkbox: {
        '& .MuiSvgIcon-root': {
            fontSize: '18px'
        }
    },
    checkboxMain: {
        '& .au-checkbox-outline-checked': {
            fill: '#003168'
        },
        '& .MuiSvgIcon-root': {
            backgroundColor: 'transparent',
            fill: 'rgba(0, 49, 104, 0.9)',
            fontSize: '16px'
        },
        '&.Mui-focusVisible': {
            outline: 'none'
        },
        color: '#A3A3A3',
        fill: '#003168'
    },
    container: {
        '@media (max-width: 1200px)': {
            paddingLeft: '60px'
        },
        '@media (max-width: 970px)': {
            paddingLeft: '60px'
        },
        maxWidth: '850px',
        paddingLeft: '100px',
        paddingTop: '120px'
    },
    containerAlternative: {
        backgroundColor: 'rgba(0, 106, 195, 0.7)',
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
        marginTop: '393px',
        paddingBottom: '47px',
        paddingLeft: '92px',
        paddingTop: '47px',
        whiteSpace: 'pre-wrap'
    },
    containerDX: {
        '@media screen and (max-width: 1000px)': {
            display: 'none'
        },
        '@media screen and (min-width: 1000px) and (max-width: 1017.99px)': {
            paddingLeft: '73px',
        },
        '@media screen and (min-width: 1000px) and (max-width: 1312px)': {
            paddingTop: '38px',
        },
        '@media screen and (min-width: 1018px) and (max-width: 1096px)': {
            paddingLeft: '90px',
        },
        flexDirection: 'column',
        flexGrow: 1,
        paddingLeft: '134px',
        paddingTop: '132px'
    },
    containerDXFr: {
        '@media screen and (max-width: 1000px)': {
            display: 'none'
        },
        '@media screen and (min-width: 1000px) and (max-width: 1019.99px)': {
            paddingLeft: '60px',
        },
        '@media screen and (min-width: 1000px) and (max-width: 1312px)': {
            paddingTop: '38px'
        },
        '@media screen and (min-width: 1020px) and (max-width: 1042.99px)': {
            paddingLeft: '80px',
        },
        '@media screen and (min-width: 1043px) and (max-width: 1086px)': {
            paddingLeft: '100px',
        },
        flexDirection: 'column',
        flexGrow: 1,
        paddingLeft: '134px',
        paddingTop: '132px'
    },
    // HedgeX specific styles
    containerHedgeX: {
        '@media screen and (max-width: 1000px)': {
            display: 'none'
        },
        '@media screen and (min-width: 1001px) and (max-width: 1025.99px)': {
            paddingLeft: '45px'
        },
        '@media screen and (min-width: 1026px) and (max-width: 1075.99px)': {
            paddingLeft: '60px'
        },
        '@media screen and (min-width: 1076px) and (max-width: 1100.99px)': {
            paddingLeft: '75px'
        },
        '@media screen and (min-width: 1101px) and (max-width: 1150px)': {
            paddingLeft: '90px'
        },
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        paddingLeft: '134px',
        paddingTop: '132px'
    },
    containerMain: {
        '@media (max-width: 1200px)': {
            paddingLeft: '60px'
        },
        '@media screen and (max-width: 900px)': {
            display: 'none'
        },
        flexDirection: 'column',
        flexGrow: 1,
        marginTop: '5.6vh',
        maxWidth: '850px',
        paddingLeft: '134px',
        paddingTop: '125px'
    },
    containerMataEn: {
        '@media screen and (max-width: 1000px)': {
            display: 'none'
        },
        '@media screen and (min-width: 1001px) and (max-width: 1025.99px)': {
            paddingLeft: '45px'
        },
        '@media screen and (min-width: 1026px) and (max-width: 1075.99px)': {
            paddingLeft: '60px'
        },
        '@media screen and (min-width: 1076px) and (max-width: 1100.99px)': {
            paddingLeft: '75px'
        },
        '@media screen and (min-width: 1101px) and (max-width: 1150px)': {
            paddingLeft: '90px'
        },
        flexDirection: 'column',
        flexGrow: 1,
        paddingLeft: '134px',
        paddingTop: '132px'
    },
    containerMataFr: {
        '@media screen and (max-width: 1000px)': {
            display: 'none'
        },
        '@media screen and (min-width: 1001px) and (max-width: 1010.99px)': {
            paddingLeft: '28px'
        },
        '@media screen and (min-width: 1011px) and (max-width: 1020.99px)': {
            paddingLeft: '39px'
        },
        '@media screen and (min-width: 1021px) and (max-width: 1058.99px)': {
            paddingLeft: '47px'
        },
        '@media screen and (min-width: 1059px) and (max-width: 1088.99px)': {
            paddingLeft: '60px'
        },
        '@media screen and (min-width: 1089px) and (max-width: 1150px)': {
            paddingLeft: '100px'
        },
        flexDirection: 'column',
        flexGrow: 1,
        paddingLeft: '134px',
        paddingTop: '132px'
    },
    customBannerBox: {
        '@media screen and (max-width: 1100px)': {
            height: '57px',
            width: '200px',
        },
        alignItems: 'center',
        backgroundColor: 'rgba(255,255,255,0.10)',
        borderRadius: '2px',
        display: 'flex',
        height: '57px',
        justifyContent: 'center',
        width: '213px'
    },
    customBannerBoxesEn: {
        '@media screen and (min-width: 1000px) and (max-width: 1335px)': {
            marginTop: '17.5px'
        },
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '30px',
        marginTop: '35px'
    },
    customBannerBoxesFr: {
        '@media screen and (min-width: 1000px) and (max-width: 1564px)': {
            marginTop: '20px'
        },
        display: 'flex',
        flexWrap: 'wrap',
        gap: '16px',
        marginBottom: '30px',
        marginTop: '40px'
    },
    customBannerBoxTitle: {
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '22px',
        fontWeight: 500,
        lineHeight: '25px'
    },
    defaultCursor: {
        cursor: 'default'
    },
    description: {
        '@media (max-width: 1200px)': {
            fontSize: '15px',
            letterSpacing: '0',
            lineHeight: '135%',
            marginTop: '10px'
        },
        color: '#FFFFFF',
        fontSize: '20px',
        fontWeight: '300',
        lineHeight: '24px',
        marginTop: '20px',
        whiteSpace: 'pre-wrap'
    },
    descriptionAlternative: {
        '@media (max-width: 1200px)': {
            fontSize: '15px',
            letterSpacing: '0',
            lineHeight: '135%'
        },
        color: '#FFFFFF',
        fontSize: '20px',
        fontWeight: '300',
        lineHeight: '24px',
        paddingTop: '24px'
    },
    descriptionDefault: {
        '@media (max-width: 1200px)': {
            fontSize: '15px',
            letterSpacing: '0',
            lineHeight: '135%',
            marginTop: '10px'
        },
        color: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: '400',
        lineHeight: '24px',
        marginTop: '20px',
        whiteSpace: 'pre-wrap'
    },
    descriptionTop: {
        '@media (max-width: 1200px)': {
            fontSize: '15px',
            letterSpacing: '0',
            lineHeight: '135%'
        },
        color: '#FFFFFF',
        fontSize: '20px',
        fontWeight: '300',
        lineHeight: '24px',
        paddingBottom: '14px'
    },
    firstDivider: {
        marginRight: '15px'
    },
    lastDivider: {
        marginLeft: '15px'
    },
    or:{
        paddingTop: '2px',
        color: '#757575',
        fontSize: '14px',
    },
    divider: {
        borderTop: '1px solid #dadada',
        lineHeight: '20px',
        margin: '11px 0 20px 0',
        textAlign: 'center',
        width: '90%'
    },
    orContainer:{
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '10px'
    },
    passwordLessMsgText: {
        paddingBottom: '8px',
        whiteSpace: 'pre-line'
    },
    emailContainer: {
        paddingBottom: '15px',
        paddingTop: '10px'
    },
    emailContainerCentral: {
        marginTop: '14px',
        minHeight: '100px'
    },
    emailContainerField: {
        minHeight: '80px'
    },
    emailMainContainer: {
        marginTop: '5vh',
        paddingBottom: '15px',
        paddingTop: '10px'
    },
    footerDivider: {
        backgroundColor: 'rgba(255,255,255,0.45)',
        borderWidth: '1px',
        fontSize: '12px',
        fontWeight: '400',
        height: '15px',
        lineHeight: '20px',
        marginTop: '5px'
    },
    forgotPassword: {
        alignSelf: 'start',
        display: 'flex',
        fontSize: '14px'
    },
    forgotPasswordBoxCustom: {
        marginLeft: 'auto'
    },
    forgotPasswordCustom: {
        color: '#003168',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '16px'
    },
    forgotPasswordMain: {
        alignSelf: 'start',
        color: '#003168',
        display: 'flex',
        fontSize: '14px'
    },
    forgotPasswordMsg: {
        color: theme => theme.palette.error.main
    },
    forgotPasswordSuccessMsg: {
        color: theme => theme.palette.success.main
    },
    passwordLessTooManyErr : {
        marginTop: '20px',
        padding: '17px 16px 6px 16px',
        backgroundColor: 'rgba(254, 205, 210, 0.32)',
        height: 'auto',
        borderRadius: '6px',
        color: 'rgba(0, 0, 0, 0.7)',
        fontSize: '16px',
        lineHeight: '175%',
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        gap: '10px'
    },
    passwordLessSuccessMsg: {
        marginTop: '20px',
        padding: '17px 16px 6px 16px',
        borderRadius: '6px',
        backgroundColor: '#B2EBF252',
        height: 'auto',
        color: 'rgba(0, 0, 0, 0.7)',
        fontSize: '16px',
        lineHeight: '175%',
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        gap: '10px'
    },
    forgotPwdResponse: {
        fontSize: '14px',
        margin: '10px 0 15px 0'
    },
    frenchInfoContainer: {
        display: 'flex',
        height: 'fit-content',
        marginTop: '15px',
        width: '100%',
    },
    frenchInfoContainerMain: {
        backgroundColor: '#677589',
        color: '#FFFFFF',
    },
    grid: {
        '@media screen and (max-width: 767px)': {
            display: 'none'
        },
        backgroundPosition: 'center center',
        backgroundPositionX: '50%',
        backgroundPositionY: '50%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
    },
    gridCustom: {
        '@media screen and (max-width: 767px)': {
            display: 'none'
        },
        backgroundPosition: 'center center',
        backgroundPositionX: '50%',
        backgroundPositionY: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'opacity 0.5s ease-in-out',
        width: 'calc(100% - 531px)'
    },
    gridCustomFr: {
        '@media screen and (max-width: 767px)': {
            display: 'none'
        },
        backgroundPosition: 'center center',
        backgroundPositionX: '50%',
        backgroundPositionY: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'opacity 0.5s ease-in-out',
        width: 'calc(100% - 531px)'
    },
    gridMain: {
        '@media screen and (max-width: 767px)': {
            display: 'none'
        },
        backgroundPosition: 'center center',
        backgroundPositionX: '50%',
        backgroundPositionY: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        transition: 'opacity 0.5s ease-in-out',
        width: 'calc(100% - 531px)'
    },
    header: {
        color: '#006AC3',
        fontFamily: 'Roboto',
        fontSize: '32px',
        fontWeight: '500',
        letterSpacing: '0',
        lineHeight: '32px'
    },
    headerDivider: {
        backgroundColor: '#FFC72C',
        height: '3px',
        margin: '12px 0px 12px 0',
        width: '40px'
    },
    hedgexContentBox: {
        '@media screen and (min-width: 1000px) and (max-width: 1100px)': {
            padding: '24px',
            width: '500px',
        },
        '@media screen and (min-width: 1101px) and (max-width: 1200px)': {
            padding: '28px',
            width: '600px',
        },
        '@media screen and (min-width: 1201px) and (max-width: 1400px)': {
            width: '800px',
        },
        background: '#052B62',
        borderRadius: '0px',
        padding: '32px',
        width: '1090px'
    },
    hedgexDescription: {
        '@media screen and (min-width: 1000px) and (max-width: 1200px)': {
            fontSize: '20px',
            lineHeight: '24px'
        },
        color: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: '28px'
    }, 
    hedgexHeaderBox: {
        '@media screen and (min-width: 1000px) and (max-width: 1100px)': {
            padding: '20px 24px',
            width: '500px',
        },
        '@media screen and (min-width: 1101px) and (max-width: 1200px)': {
            padding: '22px 28px',
            width: '600px',
        },
        '@media screen and (min-width: 1201px) and (max-width: 1400px)': {
            width: '700px',
        },
        background: '#052B62',
        borderRadius: '0px',
        marginBottom: '20px',
        padding: '24px 32px',
        width: '907px'
    },
    hedgexTitle: {
        '@media screen and (min-width: 1000px) and (max-width: 1200px)': {
            fontSize: '40px',
            lineHeight: '50px'
        },
        color: '#FFFFFF',
        display: 'flex',
        fontFamily: 'Roboto',
        fontSize: '50px',
        fontWeight: 600,
        letterSpacing: '0.46px',
        lineHeight: '62px',
        textTransform: 'capitalize'
    },
    innerOr: {
        background: '#ffffff',
        color: '#5B6169',
        fontFamily: 'Roboto',
        fontSize: '14px',
        lineHeight: '20px',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '-10px',
        textAlign: 'center',
        width: '35px'
    },
    input: {
        minHeight: '22px'
    },
    inputCustom: {
        '& .MuiInputBase-root.MuiInput-root::after': {
            borderBottom: '2px solid #006AC3'
        },
        '@media screen and (max-width: 767px)': {
            minWidth: '310px'
        },
        marginBottom: '10px',
        minWidth: '400px'
    },
    inputCustomLabelProps: {
        '&.Mui-focused': {
            color: '#003168'
        },
        color: 'rgba(0,49,104,0.54)',
        fontFamily: 'Roboto',
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '0.1px',
        lineHeight: '20px'
    },
    inputCustomShowPassword: {
        color: 'rgba(0,49,104,0.54)'
    },
    inputMain: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                border: '1px solid rgba(0,49,104,0.25)',
                borderRadius: '2px'
            },
            '&.Mui-focused fieldset': {
                border: '1px solid #003168',
                borderRadius: '2px'
            },
            '&:hover fieldset': {
                border: '1px solid #003168',
                borderRadius: '2px'
            },
            border: '1px solid rgba(0,49,104,0.25)',
            borderRadius: '2px'
        },
        minHeight: '22px'
    },
    languageButton: {
        boxShadow: 'none',
        color: 'white',
        float: 'right',
        margin: '10px',
        width: '120px'
    },
    languageIconContainerMain: {
        float: 'right',
        marginRight: '20px',
        marginTop: '25px'
    },
    leftContainer: {
        '@media screen and (max-width: 431px)': {
            flexBasis: '100%',
            maxWidth: '100%',
            paddingLeft: '40px',
            paddingRight: '40px',
            paddingTop: '40px',
            width: '100%'
        },
        '@media screen and (max-width: 767px)': {
            flexBasis: '100%',
            maxWidth: '100%',
            width: '100%'
        },
        background: '#FFFFFF',
        paddingLeft: '64px',
        paddingRight: '67px',
        paddingTop: '80px',
        width: '531px'
    },
    leftContainerCustom: {
        '@media screen and (max-width: 431px)': {
            flexBasis: '100%',
            maxWidth: '100%',
            paddingLeft: '40px',
            paddingRight: '40px',
            paddingTop: '40px',
            width: '100%'
        },
        '@media screen and (max-width: 767px)': {
            flexBasis: '100%',
            maxWidth: '100%',
            width: '100%'
        },
        background: '#FFFFFF',
        paddingLeft: '64px',
        paddingRight: '67px',
        paddingTop: '80px',
        width: '531px'
    },
    link: {
        '@media (max-width: 1200px)': {
            fontSize: '15px',
            letterSpacing: '0',
            lineHeight: '135%'
        },
        color: '#FFC72C',
        fontSize: '20px',
        fontWeight: '400',
        lineHeight: '24px',
        textDecorationThickness: '1px'
    },
    linkContainer: {
        '@media screen and (max-width: 767px)': {
            display: 'none'
        },
        '@media screen and (max-width: 920px)': {
            paddingRight: '20px'
        },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: '20px',
        paddingRight: '42px'
    },
    linkContainerMobile: {
        '@media (max-width: 1200px)': {
            justifyContent: 'center'
        },
        '@media screen and (min-width: 767px)': {
            display: 'none'
        },
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end'
    },
    linkMain: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        '@media screen and (max-width: 767px)': {
            color: '#2F2F2F'
        },
        alignSelf: 'start',
        color: '#FFFFFF',
        display: 'block',
        fontSize: '12px',
        letterSpacing: '0',
        lineHeight: '24px',
        paddingLeft: '13px',
        paddingRight: '10px'
    },
    linkMainCustom: {
        '&[disabled]': {
            cursor: 'default',
            pointerEvents: 'none'
        },
        alignSelf: 'start',
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '20px',
        paddingLeft: '13px',
        paddingRight: '10px'
    },
    loginBox: {
        '@media screen and (max-width: 380px)': {
            marginTop: '0px'
        },
        display: 'flex',
        justifyContent: 'center',
        marginTop: '48px'
    },
    loginContainer: {
        display: 'flex',
        minHeight: '90vh'
    },
    loginContainerCustom: {
        display: 'flex',
        minHeight: '90vh'
    },
    loginContainerGrid: {
        display: 'inline'
    },
    loginForm: {
        marginTop: '22px'
    },
    loginPage: {
        display: 'flex',
        flex: '1',
        height: '100vh'
    },
    loginPageCustom: {
        display: 'flex',
        flex: '1',
        height: '100vh',
        width: '100%'
    },
    loginText: {
        color: '#003168',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '34px',
        fontWeight: '500',
        textAlign: 'left'
    },
    loginTextContainer: {
        height: '41px',
        paddingLeft: '16px',
        width: '331px'
    },
    loginTextContainerCustom: {
        marginTop: '36px'
    },
    loginTextContainerFrDX: {
        marginTop: '35px'
    },
    loginTextCustom: {
        color: '#003168',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '34px',
        fontWeight: '400'
    },
    logoContainer: {
        height: '90px'
    },
    logoContainerDefault: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    logoContainerMain: {
        height: '90px'
    },
    logoEn: {
        marginBottom: '40px'
    },
    logoFr: {
        marginBottom: '40px'
    },
    logoutIframe: {
        display: 'none'
    },
    mataLogo: {
        '@media screen and (max-width: 767px)': {
            height: '71px',
            width: '200px'
        },
        height: '89px',
        width: '255.07px'
    },
    mobileLanguageButton: {
        '@media screen and (min-width: 767px)': {
            display: 'none'
        },
        color: 'rgb(0, 81, 165)',
        float: 'right',
        fontSize: '10px',
        marginLeft: '65%',
        width: '35%'
    },
    mobileLanguageButtonDefault: {
        '@media screen and (min-width: 767px)': {
            display: 'none'
        },
        color: 'rgb(0, 81, 165)',
        float: 'right',
        fontSize: '10px',
        marginTop: '10px',
        width: '35%'
    },
    moreInfoText: {
        color: '#424242',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: '300',
        lineHeight: '18px',
        margin: '0 0 30px 0'
    },
    needHelpBoxCustom: {
        '@media screen and (max-width: 395px)': {
            marginBottom: '25px'
        },
        '@media screen and (min-width: 396px) and (max-width: 767px)': {
            marginBottom: '38px'
        },
        height: '16px',
        marginBottom: '40px'
    },
    needHelpBoxDX: {
        '@media screen and (max-width: 395px)': {
            marginBottom: '40px'
        },
        '@media screen and (min-width: 396px) and (max-width: 767px)': {
            marginBottom: '60px'
        },
        height: '16px',
        marginBottom: '40px'
    },
    needHelpTextCustom: {
        color: '#60666D',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '16px'
    },
    orDivider: {
        borderTop: '1px solid #dadada',
        lineHeight: '20px',
        margin: '11px 0 10px 0',
        textAlign: 'center',
        width: '100%'
    },
    passwordIcon: {
        '& .MuiSvgIcon-root': {
            fill: 'rgba(0, 49, 104, 0.54)'
        }
    },
    rbccmOnlineContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    },
    rbcdxLogoContainer: {
        marginTop: '12.5px'
    },
    rbcdxQRBoxChipEn: {
        borderRadius: '100px',
        fontFamily: 'RBCDisplay Regular',
        fontWeight: 'bold',
        height: '32px',
        marginRight: '20px',
    },
    rbcdxQRBoxChipFr: {
        borderRadius: '100px',
        fontFamily: 'RBCDisplay Regular',
        fontWeight: 'bold',
        height: '32px',
        marginRight: '10px',
    },
    rbcdxQRBoxContentEn: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: '15px',
        paddingTop: '15px'
    },
    rbcdxQRBoxContentFr: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: '15px',
        paddingTop: '18px'
    },
    rbcdxQRBoxTitleEn: {
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '22px',
        fontWeight: 500,
        height: '22px',
        letterSpacing: '0%',
        lineHeight: '100%',
        width: '250px'
    },
    rbcdxQRBoxTitleFr: {
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '22px',
        fontWeight: 500,
        height: '22px',
        letterSpacing: '0%',
        lineHeight: '100%'
    },
    rbcdxQRCodeScannerAsset: {
        display: 'block',
        height: '160px',
        width: '160px'
    },
    rbcdxQRCodeScannerEn: {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        marginTop: '-10px'
    },
    rbcdxQRCodeScannerFr: {
        '@media screen and (max-width: 1312px)': {
            marginTop: '10px',
        },
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        marginTop: '-10px'
    },
    rbcdxQRContainerEn: {
        '@media screen and (max-width: 1481px)': {
            marginTop: '20px',
        },
        alignSelf: 'flex-start',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        height: '257px',
        justifyContent: 'center',
        marginBottom: '30px',
        marginTop: '40px',
        width: '353px'
    },
    rbcdxQRContainerFr: {
        '@media screen and (max-width: 1312px)': {
            height: '265px',
            width: '376px',
        },
        '@media screen and (max-width: 1480px)': {
            marginTop: '20px',
        },
        alignSelf: 'flex-start',
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '4px',
        display: 'flex',
        flexDirection: 'column',
        height: '260px',
        justifyContent: 'center',
        marginBottom: '40px',
        marginTop: '25px',
        width: '460px'
    },
    rememberMeContainer: {
        marginTop: '3px'
    },
    rememberMeContainerCustom: {
        '@media screen and (max-width: 767px)': {
            width: '100%'
        },
        display: 'flex',
        justifyContent: 'space-between',
        width: '400px'
    },
    rememberMeContainerMain: {
        paddingBottom: '15px'
    },
    rememberMeLabel: {
        color: '#565656',
        fontFamily: 'Roboto',
        fontSize: '14px',
        lineHeight: '1',
        marginLeft: '3px'
    },
    rememberMeLabelMain: {
        color: '#60666D',
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '18px',
        marginLeft: '10px'
    },
    title: {
        '@media (max-width: 1200px)': {
            fontSize: '44px'
        },
        color: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: '57px',
        lineHeight: '64px',
        whiteSpace: 'pre-line'
    },
    titleAlernative: {
        color: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: '45px',
        lineHeight: '45px'
    },
    titleDefault: {
        '@media (max-width: 1200px)': {
            fontSize: '44px'
        },
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '52px',
        fontWeight: '500',
        lineHeight: '62px',
        whiteSpace: 'pre-line'
    },
    titleItalic: {
        fontStyle: 'italic',
        fontWeight: 300
    },
    welcomeHeaderDescDX: {
        '@media screen and (min-width: 1000px) and (max-width: 1312.99px)': {
            width: '383px'
        },
        '@media screen and (min-width: 1313px) and (max-width: 1354.99px)': {
            width: '613px'
        },
        '@media screen and (min-width: 1355px) and (max-width: 1480.99px)': {
            width: '688px'
        },
        '@media screen and (min-width: 1481px)': {
            width: '814px'
        },
        color: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '25px',
        marginTop: '10px',
    },
    welcomeHeaderDescMata: {
        '@media screen and (min-width: 1000px) and (max-width: 1170px)': {
            width: '425px'
        },
        '@media screen and (min-width: 1171px) and (max-width: 1220px)': {
            width: '486px'
        },
        '@media screen and (min-width: 1221px) and (max-width: 1335px)': {
            width: '534px'
        },
        '@media screen and (min-width: 1336px) and (max-width: 1564px)': {
            width: '670px'
        },
        '@media screen and (min-width: 1565px)': {
            width: '884px'
        },
        color: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: '18px',
        fontWeight: 400,
        lineHeight: '25px',
        marginTop: '10px'
    },
    welcomeHeaderMata: {
        '@media screen and (min-width: 1258px) and (max-width: 1357px)': {
            width: '530px'
        },
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '52px',
        fontWeight: 500,
        lineHeight: '62px'
    },
    welcomeSubHeader: {
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '54px',
        fontWeight: 500,
        lineHeight: '65px'
    },
    welcomeSubHeaderDX: {
        '@media screen and (min-width: 1000px) and (max-width: 1312px)': {
            width: '397px',
        },
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '54px',
        fontWeight: 500,
        lineHeight: '65px'
    },
    welcomeSubHeaderMata: {
        '@media screen and (min-width: 1000px) and (max-width: 1150px)': {
            width: '371px'
        },
        '@media screen and (min-width: 1151px) and (max-width: 1335px)': {
            width: '377px'
        },
        '@media screen and (min-width: 1336px) and (max-width: 1357px)': {
            width: '662px'
        },
        color: '#FFFFFF',
        fontFamily: 'RBCDisplay Regular',
        fontSize: '54px',
        fontWeight: 500,
        lineHeight: '65px'
    },
}
